import React, { forwardRef } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL, trackCheckout } from '../utils/checkout';
type CTAButtonProps = {
  label: string;
  subLabel?: string;
  price?: string;
  compact?: boolean;
  shake?: boolean;
  className?: string;
};
export const CTAButton = forwardRef<HTMLAnchorElement, CTAButtonProps>(function CTAButton({
  label,
  subLabel,
  price,
  compact = false,
  shake = false,
  className = ''
}, ref) {
  return <a ref={ref} href={CHECKOUT_URL} onClick={trackCheckout} className={`group flex w-full items-center justify-center gap-3 rounded-2xl bg-cta text-ink shadow-[0_12px_28px_-12px_rgba(31,214,127,0.75)] transition-[transform,background-color] duration-150 ease-out hover:bg-cta-light active:scale-[0.98] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-cta/40 ${compact ? 'px-4 py-3.5' : 'px-5 py-4 sm:px-7 sm:py-5'} ${shake ? 'animate-cta-shake' : ''} ${className}`} data-id="element-31" data-mp="2tx03etivf2un">
      <span className="flex min-w-0 flex-col text-center" data-id="element-32" data-mp="199oeofrmx7sr">
        <span className={`text-balance font-display font-extrabold uppercase leading-[1.15] tracking-tight ${compact ? 'text-[13px] min-[380px]:text-[15px] sm:text-base' : 'text-[17px] sm:text-xl'}`} data-id="element-33" data-mp="19b9985dy8qqm">
          {label}
        </span>
        {subLabel && <span className="mt-1 text-xs font-semibold text-ink/70 sm:text-[13px]" data-id="element-34" data-mp="1n6bd6mz8k60s">{subLabel}</span>}
      </span>
      {price ? <span className="shrink-0 rounded-lg bg-ink px-2.5 py-1 font-display text-base font-black text-cta" data-id="element-35" data-mp="1w8kjt1rdvf8w">
          {price}
        </span> : <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-36" data-mp="2125k50gg8lb9" />}
    </a>;
});